import * as React from 'react';

function SvgPropertyOutline(props) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#property-outline_svg__clip0_1006_18598)" fill="#000" fillOpacity={0.45}>
        <path d="M2.953 2.953h.985v.985h-.985v-.985zM3.938 4.922h-.985v.984h.985v-.984zM2.953 6.89h.985v.985h-.985v-.984zM6.016 2.953H5.03v.985h.985v-.985zM5.031 4.922h.985v.984H5.03v-.984zM6.016 6.89H5.03v.985h.985v-.984z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M.984 1.969c0-.544.441-.985.985-.985H7c.544 0 .984.441.984.985v2.898h4.54a.492.492 0 01.49.535.59.59 0 01.002.046v6.583c0 .544-.441.985-.985.985H1.97a.984.984 0 01-.985-.985V1.97zm11.047 5.797H7.984v4.265h1.258v-1.86h1.531v1.86h1.258V7.766zm0-.985v-.93H7.984v.93h4.047zM7 1.97V12.03H1.969V1.97H7z"
        />
      </g>
      <defs>
        <clipPath id="property-outline_svg__clip0_1006_18598">
          <path fill="#fff" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgPropertyOutline;
